// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ImagesRollupPlugin {
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'ImagesRo... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   invoke(data: any, feed: any) {
      const rollup = data.search.rollups.image
      if (rollup && (rollup.documents != null) && (rollup.documents.length > 4)) {
         const item = {
            documents: rollup.documents,
            type: 'imagesRollup',
            query: data.search.query.original_query,
            filters: rollup.filters
         }
         return feed.addPositionalItem(item, rollup.position)
      }
   }
}
ImagesRollupPlugin.initClass()

angular.module('summonApp.resultsFeedPlugins')
   .service('imagesRollupPlugin', ImagesRollupPlugin)
